import { useSearchParams } from 'next/navigation'

export const useAdminMode = () => {
  const searchParams = useSearchParams()
  const isAdminMode = searchParams.get('admin') === 'true'
  const currentOrganizationId = searchParams.get('organizationId') || undefined

  const buildUrlWithAdminParams = (basePath: string) => {
    if (!isAdminMode) return basePath
    const params = new URLSearchParams()
    params.set('admin', 'true')
    if (currentOrganizationId) params.set('organizationId', currentOrganizationId)
    return `${basePath}?${params.toString()}`
  }

  return { isAdminMode, currentOrganizationId, buildUrlWithAdminParams }
}
